// extracted by mini-css-extract-plugin
export default {"information":"Information_information__X62-A","label":"Information_label__fYoJS"};